import React from 'react';
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as ROUTES from '../../../constants/routes';
import * as MDICONS from '@material-ui/icons';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect, firestoreConnect } from 'react-redux-firebase';



const StyledSideNav = styled.div`
    position: fixed;
    height: 100%;
    width: ${(props) => props.dashboardSidebarSize};
    z-index: 1;
    top: 3.4em;
    background-color: ${(props) => props.themeColors.darkThemeColor};
    border-right: 2px solid ${(props) => props.themeColors.themeColor};
    border-top: 15px solid ${(props) => props.themeColors.themeColor};
    overflow-x: hidden;
    padding-top: 20px;
    padding-left: 0px;
    `;

const StyledNavItem = styled.div`
    height: 60px;
    width: ${(props) => props.dashboardSidebarSize};
    margin-bottom: 0;
    text-align: left;

    a {
        font-size: 1em;
        color: ${(props) => props.active ? "#fafafa" : "#fafafa"};
        :hover {
            opacity: 0.7;
            text-decoration: none;
        }
    }
`;

const LinkButton = styled.div`
    .btn {
        color: rgba(255, 255, 255, 0.8);
        border-color: transparent;
        background-color: transparent;
        margin: 0px;

        &:hover {
            color: rgba(255, 255, 255, 1);
            text-decoration: underline;
        }

        &:active {
            color: rgba(255, 255, 255, 1);
        }
    }
`;

const NavIcon = styled.div`
`;

///
class DashboardNav extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activePath: window.location.pathname ?? ROUTES.HOME_PROJECTS,
            items: [
                {
                    path: ROUTES.HOME_PROJECTS, /* path is used as id to check which NavItem is active basically */
                    name: 'Home',
                    icon: <MDICONS.DashboardRounded />,
                    key: 1 /* Key is required, else console throws error. Does this please you Mr. Browser?! */
                },
                {
                    path: ROUTES.HOME_COMPANY,
                    name: 'Company',
                    icon: <MDICONS.ApartmentRounded />,
                    key: 2
                },
                // {
                //     path: ROUTES.USER_PROFILE,
                //     name: 'Profile',
                //     icon: <MDICONS.AccountBoxRounded />,
                //     key: 3
                // },
                {
                    path: ROUTES.PRICING,
                    name: 'Pricing',
                    icon: <MDICONS.SettingsApplications />,
                    key: 4
                },
                // Todo: We need to decide what this folder do....

                // {
                //     path: ROUTES.HOME_FOLDERS,
                //     name: 'Files',
                //     icon: <MDICONS.FolderSharedRounded />,
                //     key: 5
                // },
            ],
            specificItems: [
                {
                    path: ROUTES.HOME_PROJECTS, /* path is used as id to check which NavItem is active basically */
                    name: 'Home',
                    icon: <MDICONS.DashboardRounded />,
                    key: 1 /* Key is required, else console throws error. Does this please you Mr. Browser?! */
                },
                // {
                //     path: ROUTES.USER_PROFILE,
                //     name: 'Profile',
                //     icon: <MDICONS.AccountBoxRounded />,
                //     key: 3
                // },
                {
                    path: ROUTES.PRICING,
                    name: 'Pricing',
                    icon: <MDICONS.SettingsApplications />,
                    key: 4
                },
                // Todo: We need to decide what this folder do....

                // {
                //     path: ROUTES.HOME_FOLDERS,
                //     name: 'Files',
                //     icon: <MDICONS.FolderSharedRounded />,
                //     key: 5
                // },
            ]
        }
    }

    onItemClick = (path) => {
        this.setState({
            activePath: path,
        })
    }

    handleToggle = (e) => {
        e.preventDefault();
        // console.log(this.props.sidebar);
        this.props.sidebar.sidebarToggle(!this.props.sidebar.dashboardSidebarToggle);
    }

    render() {
        const { items, activePath, specificItems } = this.state;
        const { themeColors, dashboardSidebarSize, dashboardSidebarToggle, companyData } = this.props.sidebar;
        // console.log(companyData)
        const arrowLink = dashboardSidebarToggle ? <MDICONS.ChevronLeft /> : <MDICONS.ChevronRight />
        return (
            <StyledSideNav dashboardSidebarSize={dashboardSidebarSize} themeColors={themeColors}>
                <div className="d-flex flex-column">
                    <div className="align-self-start">
                        <LinkButton>
                            <button className="btn btn-default mb-3" onClick={this.handleToggle}>{arrowLink}</button>
                        </LinkButton>
                    </div>
                    <div className="align-self-center ml-4">


                        {
                            companyData !== undefined && companyData !== null ?
                                items.map((item) => {
                                    return (
                                        <DashboardNavItem
                                            path={item.path}
                                            name={dashboardSidebarToggle ? item.name : ""}
                                            icon={item.icon}
                                            onItemClick={this.onItemClick}
                                            active={item.path === activePath}
                                            key={item.key}
                                            dashboardSidebarSize={dashboardSidebarSize}
                                            themeColors={themeColors}
                                        />
                                    )
                                })
                                :
                                specificItems.map((specificItem) => {
                                    return (
                                        <DashboardNavItem
                                            path={specificItem.path}
                                            name={dashboardSidebarToggle ? specificItem.name : ""}
                                            icon={specificItem.icon}
                                            onItemClick={this.onItemClick}
                                            active={specificItem.path === activePath}
                                            key={specificItem.key}
                                            dashboardSidebarSize={dashboardSidebarSize}
                                            themeColors={themeColors}
                                        />
                                    )
                                })
                        }
                    </div>
                </div>
            </StyledSideNav>
        );
    }
}

class DashboardNavItem extends React.Component {

    handleClick = () => {
        const { path, onItemClick } = this.props;
        onItemClick(path);
    }

    render() {
        const { active, themeColors, dashboardSidebarSize } = this.props;

        return (
            <StyledNavItem active={active} dashboardSidebarSize={dashboardSidebarSize} themeColors={themeColors}>
                <Link to={this.props.path} onClick={this.handleClick}>
                    <NavIcon>
                        {this.props.icon}
                        <i style={{ marginRight: "15px" }} />
                        {this.props.name}
                    </NavIcon>
                </Link>
            </StyledNavItem>
        )
    }
}

class DashboardSidebar extends React.Component {
    render() {
        return (
            <div style={{ visibility: 'hidden' }}>
                <DashboardNav sidebar={this.props} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        companyData: state.firestore.data.Company,
        themeColors: state.theme,
        dashboardSidebarToggle: state.appControl.dashboardSidebarToggle,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        userData: state.firebase.profile,
        project: state.project,

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        sidebarToggle: (toggle) => {
            dispatch({
                type: 'DASHBOARD_TOGGLE',
                toggle: toggle,
            })
        }
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firebaseConnect((props) => {
        return [
            `CompaniesMeta/${props.userData.coid}/Notifications`
        ]
    }),
    firestoreConnect((props) => {
        console.log("compose sidebar")
        const { userData, project, companyData } = props;
        let proid = project.proid;
        let ueid = `${userData.uid}${userData.employeeid}`;
        let boughtOrderId = companyData ? 'boughtSubscription' in companyData ? companyData.boughtSubscription.orderId : '-1' : '-1';
        // console.log(boughtOrderId);
        return [
            {
                collection: "Companies",
                storeAs: "Company",
                doc: props.userData.coid,
            },
            {
                collection: `Users/${props.userData.uid}/Notifications`,
                orderBy: ['timestamp', 'desc'],
                storeAs: "Notifications",
            },
            {
                collection: `Companies/${props.userData.coid}/Briefings`,
                storeAs: "CompanyBriefings",
                doc: "projects",
            },
            {
                collection: "Projects",
                where: [['proid', '==', proid], ['accessList', 'array-contains', ueid]],
                storeAs: "Snag",
            },
            {
                collection: "ProductOrders",
                storeAs: "ProductOrder",
                doc: boughtOrderId,
            },
            {
                collection: `Companies/${props.userData.coid}/Notifications`,
                orderBy: ['timestamp', 'desc'],
                storeAs: "CompanyNotifications",
            },
            {
                collection: "Configurations",
                doc: "CommonQuestions",
                storeAs: "CommonQuestions",
            }
        ]
    })
)(DashboardSidebar);
